import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BarRatingModule } from 'ngx-bar-rating';
import { CookieService } from 'ngx-cookie-service';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

// Header and Footer Components
import { FooterOneComponent } from './footer/footer-one/footer-one.component';
import { HeaderOneComponent } from './header/header-one/header-one.component';
//import { HeaderTwoComponent } from './header/header-two/header-two.component';
import { FooterTwoComponent } from './footer/footer-two/footer-two.component';
//import { HeaderThreeComponent } from './header/header-three/header-three.component';
import { FooterFourComponent } from './footer/footer-four/footer-four.component';
import { FooterThreeComponent } from './footer/footer-three/footer-three.component';
import { HeaderFourComponent } from './header/header-four/header-four.component';

// Components
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import { MenuComponent } from './components/menu/menu.component';
import { ProductBoxOneComponent } from './components/product/product-box-one/product-box-one.component';
import { SettingsComponent } from './components/settings/settings.component';

// Modals Components
import { AgeVerificationComponent } from './components/modal/age-verification/age-verification.component';
import { CartModalComponent } from './components/modal/cart-modal/cart-modal.component';
import { CartVariationComponent } from './components/modal/cart-variation/cart-variation.component';
import { QuickViewComponent } from './components/modal/quick-view/quick-view.component';
import { SizeModalComponent } from './components/modal/size-modal/size-modal.component';
import { VideoModalComponent } from './components/modal/video-modal/video-modal.component';

// Skeleton Loader Components
import { SkeletonProductBoxComponent } from './components/skeleton/skeleton-product-box/skeleton-product-box.component';


// Tap To Top
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';

// Pipes
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgSelectModule } from '@ng-select/ng-select';
import { GroupByPipe, NgPipesModule } from 'ngx-pipes';
import { FooterSliderComponent } from '../home/widgets/footer-slider/footer-slider.component';
import { SliderComponent } from '../home/widgets/slider/slider.component';
import { AddressComponent } from './components/modal/address/address.component';
import { NgInitDirective } from './directive/nginit.directive';
import { DiscountPipe } from './pipes/discount.pipe';
import { SliderBannerTypeFilterPipe } from './pipes/slider-banner-type.filter';
import { VariationPipe } from './pipes/variation.pipe';

@NgModule({
  declarations: [
    HeaderOneComponent,
    FooterOneComponent,
    //HeaderTwoComponent,
    FooterTwoComponent,
    //HeaderThreeComponent,
    FooterThreeComponent,
    HeaderFourComponent,
    FooterFourComponent,
    LeftMenuComponent,
    MenuComponent,
    SettingsComponent,
    BreadcrumbComponent,
    CategoriesComponent,
    ProductBoxOneComponent,
    QuickViewComponent,
    AddressComponent,
    CartModalComponent,
    CartVariationComponent,
    VideoModalComponent,
    SizeModalComponent,
    AgeVerificationComponent,
    SkeletonProductBoxComponent,
    TapToTopComponent,
    DiscountPipe,
    SliderBannerTypeFilterPipe,
    SliderComponent,
    FooterSliderComponent,
    NgInitDirective,
    VariationPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CarouselModule,
    BarRatingModule,
    LazyLoadImageModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    NgPipesModule,
    NgSelectModule,
    NgOptionHighlightModule,
    
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CarouselModule,
    BarRatingModule,
    LazyLoadImageModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    HeaderOneComponent,
    FooterOneComponent,
    //HeaderTwoComponent,
    FooterTwoComponent,
    //HeaderThreeComponent,
    FooterThreeComponent,
    HeaderFourComponent,
    FooterFourComponent,
    BreadcrumbComponent,
    CategoriesComponent,
    ProductBoxOneComponent,
    QuickViewComponent,
    AddressComponent,
    CartModalComponent,
    CartVariationComponent,
    VideoModalComponent,
    SizeModalComponent,
    AgeVerificationComponent,
    SkeletonProductBoxComponent,
    TapToTopComponent,
    DiscountPipe,
    SliderBannerTypeFilterPipe,
    NgPipesModule,
    SliderComponent,
    FooterSliderComponent,
    NgInitDirective,
    
    GroupByPipe,
    VariationPipe
  ],
  providers: [
    CookieService,
    GroupByPipe
  ]
})
export class SharedModule { }
